/**
 * defaultAnchor.tsx.
 */
import Anchor from '@shared/types/props/anchor';
import DefaultAnchorContainer from '@components/atoms/container/defaultAnchorContainer';
import DefaultAnchorImage from '@components/atoms/images/defaultAnchorImage';

export default function DefaultAnchor(props: Anchor) {
  const { asset } = props;
  return (
    <DefaultAnchorContainer>
      <DefaultAnchorImage src={asset?.channel?.logo ?? ''} />
    </DefaultAnchorContainer>
  );
}
